import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function BigQueryIcon(props: IconProps) {
  const id = useId();
  return (
    <Icon viewBox="0 0 20 20" width="20px" height="20px" fill="none" {...props}>
      <Box as="g" clipPath={`url(#bigquery-a-${id})`}>
        <Box
          as="mask"
          id={`bigquery-b-${id}`}
          width="20"
          height="20"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
          sx={{ maskType: "luminance" }}
        >
          <Box as="path" fill="#fff" d="M20 0H0v20h20V0Z" />
        </Box>
        <Box as="g" mask={`url(#bigquery-b-${id})`}>
          <Box
            as="path"
            fill="#AECBFA"
            fillRule="evenodd"
            d="M4.733 8.833v2.634a4.89 4.89 0 0 0 1.709 1.741V8.842H4.733v-.009Z"
            clipRule="evenodd"
          />
          <Box
            as="path"
            fill="#669DF6"
            fillRule="evenodd"
            d="M7.892 6.408v7.534c.366.05.741.066 1.108.058.333.025.667.025 1 0V6.408H7.892Z"
            clipRule="evenodd"
          />
          <Box
            as="path"
            fill="#AECBFA"
            fillRule="evenodd"
            d="M11.642 9.858v3.292a5.077 5.077 0 0 0 1.7-1.817V9.867h-1.7v-.009Z"
            clipRule="evenodd"
          />
          <Box
            as="path"
            fill="#4285F4"
            fillRule="evenodd"
            d="m15.742 14.317-1.417 1.416s-.075.084-.092.134a.373.373 0 0 0-.033.166c0 .059.008.109.033.167.025.05.05.1.092.133l3.542 3.542a.425.425 0 0 0 .291.125.391.391 0 0 0 .292-.125l1.433-1.433a.424.424 0 0 0 .125-.292.391.391 0 0 0-.125-.292l-3.541-3.541s-.084-.075-.134-.092a.373.373 0 0 0-.166-.033.398.398 0 0 0-.167.033.38.38 0 0 0-.133.092Z"
            clipRule="evenodd"
          />
          <Box
            as="path"
            fill="#669DF6"
            fillRule="evenodd"
            d="M9 0a8.978 8.978 0 0 0-5 1.517 8.989 8.989 0 0 0-3.825 9.241 9.044 9.044 0 0 0 2.467 4.609 9.011 9.011 0 0 0 4.608 2.466 9.029 9.029 0 0 0 5.2-.508 8.98 8.98 0 0 0 4.042-3.317 8.978 8.978 0 0 0 1.516-5 8.964 8.964 0 0 0-2.633-6.358A8.963 8.963 0 0 0 9.017.017L9 0Zm0 15.692a6.632 6.632 0 0 1-3.708-1.134 6.663 6.663 0 0 1-2.459-3A6.64 6.64 0 0 1 2.458 7.7a6.688 6.688 0 0 1 1.825-3.417 6.688 6.688 0 0 1 7.275-1.45 6.706 6.706 0 0 1 3 2.459A6.745 6.745 0 0 1 15.692 9a6.58 6.58 0 0 1-.509 2.558A6.677 6.677 0 0 1 9 15.692Z"
            clipRule="evenodd"
          />
        </Box>
      </Box>
      <Box as="defs">
        <clipPath id={`bigquery-a-${id}`}>
          <Box as="path" fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </Box>
    </Icon>
  );
}
